/**
 * This file contains S3 keys that are specific to the current environment, as opposed to the prop source files bucket that's shared across environments.
 *
 * In common since code in packages like gfx requires a subset of the keys.
 */

export const BUILT_IN_PROP_ASSETS_PREFIX = "builtin_prop_assets";

export function builtInPropThumbnailSmallUrlFromS3Location(s3Location: string): string {
  return `${BUILT_IN_PROP_ASSETS_PREFIX}/thumbnails/${s3Location}_small.png`;
}

export function builtInPropGltfUrlFromS3Location(s3Location: string): string {
  return `${BUILT_IN_PROP_ASSETS_PREFIX}/gltf/${s3Location}.glb`;
}

export function builtInPropSvgUrlFromS3Location(s3Location: string): string {
  return `${BUILT_IN_PROP_ASSETS_PREFIX}/svg/${s3Location}.svg`;
}

/**
 * We have two prop library indexes: one for released props and another one including prop batches that are still in review.
 */

/**
 * We keep the authoritative committed batch information in a single file to enable atomic updates.
 * This file is JSON and includes two keys:
 * namesById: the authoritative id to name mapping for props that have been released and are available in the generated prop library.
 * committedBatchIds: the list of batch IDs that have been released and are included in the generated prop library.
 */
export const BUILTIN_PROP_BATCHES_AND_IDS_COMMITTED_KEY = `${BUILT_IN_PROP_ASSETS_PREFIX}/index/batchIdsAndIdMapping.json`;

/** S3 key for the JSON file listing batch IDs and ID mapping included in the current index. */
export const BUILTIN_PROP_BATCHES_STAGING_KEY = `${BUILT_IN_PROP_ASSETS_PREFIX}/index/batchIdsStaging.json`;

/**
 * S3 key (within the current environment's bucket) of the released and committed prop ID mapping. The file is a JSON object mapping numeric prop IDs to prop names.
 */
export const BUILTIN_PROP_IDS_COMMITTED_KEY = `${BUILT_IN_PROP_ASSETS_PREFIX}/index/propIdsReleased.json`;

/** S3 key. This id mapping includes both released and in-review props. Ids of in-review props can change. */
export const BUILTIN_PROP_IDS_STAGING_KEY = `${BUILT_IN_PROP_ASSETS_PREFIX}/index/propIdsStaging.json`;

/** S3 key for the binary-encoded prop library file. */
export const BUILTIN_PROP_LIBRARY_BIN_COMMITTED_KEY = `${BUILT_IN_PROP_ASSETS_PREFIX}/index/propLibrary.bin`;
export const BUILTIN_PROP_LIBRARY_BIN_STAGING_KEY = `${BUILT_IN_PROP_ASSETS_PREFIX}/index/propLibraryStaging.bin`;
